module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_fv-title-d013a3a2d670ccf5bfb822900621d32e.png";